import * as React from 'react'
import {Link} from '@frontrow/console/src/components/ui/link'
import {UploadFileButton} from '@frontrow/console/src/components/upload-file-button'

import * as style from './import-row.module.scss'

export type ImportFileType = 'teachers-csv' | 'students-csv' | 'enrollments-csv' | 'courses-csv'

type Props = {
  title: string
  type: ImportFileType
  onImport: (file: File, fileType: ImportFileType) => void
  uploaded: boolean
  description: string
  templateUrl: string
}

export default function ImportRow(props: Props): React.ReactElement {
  const {title, type, onImport, uploaded, description, templateUrl} = props

  const csvTemplate = <Link href={templateUrl}>(template)</Link>

  const uploadedCheck = uploaded ? (
    <div className={style.uploadedCheck}>
      <i className="fa fa-check-circle fa-2x" />
    </div>
  ) : null

  return (
    <div className={style.importRow}>
      <div className={style.rowDescription}>
        <b className={style.title}>{title}</b>
        <br />
        {description} {csvTemplate}
      </div>
      <UploadFileButton
        buttonText={`Upload ${title} csv`}
        onPostFileUpload={file => onImport(file, type)}
      />
      {uploadedCheck}
    </div>
  )
}
